// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ChartPivotGrid__TitleCard__KZ8Gi {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  padding-right: 5px;\r\n  align-content: center;\r\n}\r\n\r\n.ChartPivotGrid__SubtitleCard__DTlHi {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  padding-right: 5px;\r\n  align-content: center;\r\n}\r\n\r\n.ChartPivotGrid__TableContainer__iFfZA {\r\n  display: flex;\r\n  flex-direction: column;\r\n  flex: 1 1;\r\n  background-color: white;\r\n  align-items: flex-end;\r\n  margin-bottom: 5px;\r\n}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"TitleCard": "ChartPivotGrid__TitleCard__KZ8Gi",
	"SubtitleCard": "ChartPivotGrid__SubtitleCard__DTlHi",
	"TableContainer": "ChartPivotGrid__TableContainer__iFfZA"
};
export default ___CSS_LOADER_EXPORT___;
